export const RECEIVE_POWER_TRANSFORMERS = 'RECEIVE_POWER_TRANSFORMERS';
export const GET_POWER_TRANSFORMERS = 'GET_POWER_TRANSFORMERS';
export const SET_POWER_TRANSFORMER = 'SET_POWER_TRANSFORMER';
export const UPDATE_POWER_TRANSFORMER = 'UPDATE_POWER_TRANSFORMER';
export const DELETE_POWER_TRANSFORMER = 'DELETE_POWER_TRANSFORMER';
export const FETCH_POWER_TRANSFORMERS = 'FETCH_POWER_TRANSFORMERS';
